import {
  getDiscountedPrice,
  getProductDiscountAmount,
} from "../../../Helpers/promotions";
import { createProductPriceQuote } from "../presentation/money";

const attachPricedPromotionName = (quote) => {
  if (!quote?.promotion || quote.promotion.name || quote.promotion.label) {
    return quote;
  }
  const pricedItem = (Array.isArray(quote.promotion.items)
    ? quote.promotion.items
    : []
  ).find(({ name }) => Boolean(name));
  if (!pricedItem) return quote;
  return {
    ...quote,
    promotion: {
      ...quote.promotion,
      name: pricedItem.name,
      type: quote.promotion.type || quote.promotion.kind,
    },
  };
};

const getSummaryAmount = (summary, field) => {
  const money = summary?.[`${field}_money`];
  if (money && Number.isFinite(Number(money.amount_minor))) {
    const fractionDigits = Number.isFinite(Number(money.fraction_digits))
      ? Number(money.fraction_digits)
      : 2;
    return Number(money.amount_minor) / 10 ** fractionDigits;
  }
  const amount = Number(summary?.[field]);
  return Number.isFinite(amount) ? amount : null;
};

export const resolveStorefrontPdpPriceSummary = ({
  product = {},
  selectedSummary,
} = {}) => {
  const productSummary = product.price_summary;
  if (product.has_variants === true) return selectedSummary || null;
  if (productSummary?.authoritative === true) return productSummary;
  if (selectedSummary?.authoritative === true) return selectedSummary;
  return selectedSummary || productSummary || null;
};

export const createStorefrontPriceQuote = ({
  coupon,
  discounts,
  product = {},
  settings = {},
  smartPromos = [],
} = {}) => {
  if (product.price_summary?.authoritative === true) {
    return attachPricedPromotionName(
      createProductPriceQuote({ product, settings }),
    );
  }

  // Non-authoritative summaries are intentionally removed so the money
  // helper cannot prefer a base-only server quote over live legacy promos.
  const hasExplicitBaseOnlySummary =
    product.price_summary?.authoritative === false;
  const summaryCurrent = hasExplicitBaseOnlySummary
    ? getSummaryAmount(product.price_summary, "current")
    : null;
  const summaryOriginal = hasExplicitBaseOnlySummary
    ? getSummaryAmount(product.price_summary, "original")
    : null;
  const legacyProduct = {
    ...product,
    ...(summaryCurrent !== null
      ? {
          options: [],
          price: summaryCurrent,
          striked_price:
            summaryOriginal !== null
              ? summaryOriginal
              : product.striked_price,
        }
      : {}),
  };
  delete legacyProduct.price_summary;
  const discountAmount = getProductDiscountAmount(
    legacyProduct,
    coupon,
    discounts,
    smartPromos,
  );
  return createProductPriceQuote({
    product: legacyProduct,
    discountedBasePrice: getDiscountedPrice(
      legacyProduct.price,
      discountAmount,
    ),
    settings,
  });
};

export const createStorefrontCardPriceQuote = createStorefrontPriceQuote;
